import { Injectable, inject } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AppDialogBoxConfig } from '@ukam/ui-kit/dialog-box/dialog-box.models';
import { AppDialogBoxComponent } from '@ukam/ui-kit/dialog-box/dialog-box.component';
import { TranslocoService } from '@jsverse/transloco';


@Injectable({
	providedIn: 'root'
})
export class AppDialogBoxService {
	private _translocoService = inject(TranslocoService);
	private _matDialog = inject(MatDialog);

	private _defaultConfig: AppDialogBoxConfig = {
		title: this._translocoService.translate('Confirm'),
		message: this._translocoService.translate('Are you sure you want to confirm this action?'),
		icon: {
			name: '',
			color: 'primary'
		},
		confirm: {
			color: 'primary'
		},
		actions: 'yesNo',
		dismissible: true
	};

	private _deleteConfig: AppDialogBoxConfig = {
		title: this._translocoService.translate('Confirm'),
		message: this._translocoService.translate('Are you sure you want to confirm this action?'),
		icon: {
			name: 'solar:shield-warning-linear',
			color: 'warn'
		},
		confirm: {
			color: 'warn'
		},
		actions: 'yesNo',
		dismissible: true
	};

	open(config: AppDialogBoxConfig = {}): MatDialogRef<AppDialogBoxComponent> {
		const userConfig = { ...this._defaultConfig, ...config };
		return this._matDialog.open(AppDialogBoxComponent, {
			autoFocus: false,
			disableClose: !userConfig.dismissible,
			data: userConfig,
			panelClass: 'ajin-dialog-box'
		});
	}

	openDelete(config: AppDialogBoxConfig = {}): MatDialogRef<AppDialogBoxComponent> {
		const userConfig = { ...this._deleteConfig, ...config };
		if (!config?.title)
			userConfig.title = this._translocoService.translate('Delete');

		if (!config?.message)
			userConfig.message = this._translocoService.translate('Do you want to delete the selected item?');

		return this._matDialog.open(AppDialogBoxComponent, {
			autoFocus: false,
			disableClose: !userConfig.dismissible,
			data: userConfig,
			panelClass: 'ajin-dialog-box'
		});
	}

	openCancel(config: AppDialogBoxConfig = {}): MatDialogRef<AppDialogBoxComponent> {
		const userConfig = { ...this._deleteConfig, ...config };

		if (!config?.title)
			userConfig.title = this._translocoService.translate('Cancel');

		if (!config?.message)
			userConfig.message = this._translocoService.translate('Do you want to cancel the selected item?');

		return this._matDialog.open(AppDialogBoxComponent, {
			autoFocus: false,
			disableClose: !userConfig.dismissible,
			data: userConfig,
			panelClass: 'ajin-dialog-box'
		});
	}

	openDeleteMany(config: AppDialogBoxConfig = {}): MatDialogRef<AppDialogBoxComponent> {
		if (!config?.message)
			config.message = this._translocoService.translate('Do you want to delete the selected items?');
		return this.openDelete(config);
	}

	openCancelMany(config: AppDialogBoxConfig = {}): MatDialogRef<AppDialogBoxComponent> {
		if (!config?.message)
			config.message = this._translocoService.translate('Do you want to cancel the selected items?');
		return this.openCancel(config);
	}

	openDeleteByParent(config: AppDialogBoxConfig = {}): MatDialogRef<AppDialogBoxComponent> {
		const userConfig = { ...this._deleteConfig, ...config };

		if (!config?.title)
			userConfig.title = this._translocoService.translate('Delete');

		if (!config?.message)
			userConfig.message = this._translocoService.translate('Do you want to delete the selected item and ?');

		return this._matDialog.open(AppDialogBoxComponent, {
			autoFocus: false,
			disableClose: !userConfig.dismissible,
			data: userConfig,
			panelClass: 'ajin-dialog-box'
		});
	}


	openRestore(config: AppDialogBoxConfig = {}): MatDialogRef<AppDialogBoxComponent> {
		const userConfig = { ...this._deleteConfig, ...config };

		if (!config?.title)
			userConfig.title = this._translocoService.translate('Restore');

		if (!config?.message)
			userConfig.message = this._translocoService.translate('Do you want to restore the selected item?');

		return this._matDialog.open(AppDialogBoxComponent, {
			autoFocus: false,
			disableClose: !userConfig.dismissible,
			data: userConfig,
			panelClass: 'ajin-dialog-box'
		});
	}

	openRestoreMany(config: AppDialogBoxConfig = {}): MatDialogRef<AppDialogBoxComponent> {
		if (!config?.message)
			config.message = this._translocoService.translate('Do you want to restore the selected items?');
		return this.openRestore(config);
	}


	openInput(config: AppDialogBoxConfig = {}): MatDialogRef<AppDialogBoxComponent> {
		const userConfig = { ...this._defaultConfig, ...config };
		userConfig.type = 'input';

		return this._matDialog.open(AppDialogBoxComponent, {
			autoFocus: false,
			disableClose: !userConfig.dismissible,
			data: userConfig,
			panelClass: 'ajin-dialog-box'
		});
	}
}
